import i18next from "i18next";
export const DEFAULT_SERVICES_MODEL = {};
export const IOSS_TIER_MAPPING = {
  Tier0: i18next.t("Pay As You Ship: \u20AC10 per month up to 5 packages, plus \u20AC2 per additional package"),
  Tier1: i18next.t("Tier 1: Up to 500 packages in a 12 month period"),
  Tier2: i18next.t("Tier 2: Up to 2500 packages in a 12 month period"),
  Tier3: i18next.t("Tier 3: Unlimited packages in a 12 month period")
};
export const PRICE_CONFIG_MOCK = void 0;
